import React, { lazy } from "react";
import AuthRoute from "../../components/auth/AuthRoute";
import RoleRoutes from "../RoleRoutes";
import ProjectsDropDown from "../../components/layout/CrmProject";
import { useEffect, useState } from "react";
import axios from "axios";
import { useMasterValues } from "../../components/common/MasterData";
import useSubmit from "../../hooks/http/useSubmit";
import urls from "../../apiService/urls";
import { toast } from "react-toastify";

export const pathName = "/crm-head";

export const paths = {
  crm: "/crm",
  sales: "/sales",
  Apartment: "/src/components/sales-manager/availability/ApartmentModal.js",
  booking: "../sales-manager/BookingDetails.js",
  costSheet: "../sales-manager/CostSheet.js",
  dashboard: "/dashboard",
  legal_documents: "/legal_documents",
  reports: "/reports",
  digital_approval: "/digital_approval",
  handover: "/handover",
  delight: "/delight",
  salesLeadReport: "/salesleadreport",
  landownerreport: "/landownerreport",

};

const CrmChoice = ({ customer_id, crm_assignee }) => {
  const data = useMasterValues()[1];
  const crm_person = Array.isArray(data?.crm_person) ? data.crm_person : [];
  const [selectedClient, setSelectedCrm] = useState([crm_assignee]);

  const [fetching, submit] = useSubmit({
    success: (data) => {
      toast.success("CRM Assigned Successfully.");

    },
  });

    console.log("Cus Id : ", customer_id)

  function handleSelectChange(event) {
    setSelectedCrm(event.target.value);
    const value = event.target.value
    const id = customer_id
    submit({
      url: urls.crmAssign,
      method: "POST",
      data: { value, id }
    });
  }
  return (
    <select value={selectedClient} onChange={handleSelectChange} fetching={fetching}>
      <option value="">CRM</option>
      {crm_person.map((x) => (
        <option value={x.id} selected>{x.user.first_name + ' ' + x.user.last_name}</option>
      ))}
    </select>
  )
}

  // Global path exports
  export const landing = `${pathName}${paths.dashboard}`;
  export const sales = `${pathName}${paths.sales}`;
  export const crm = `${pathName}${paths.crm}`;
  export const legal_documents = `${pathName}${paths.legal_documents}`;
  export const reports = `${pathName}${paths.reports}`;
  export const digital_approval = `${pathName}${paths.digital_approval}`;
  export const handover = `${pathName}${paths.handover}`;
  export const delight = `${pathName}${paths.delight}`;
  export const salesLeadReport = `${pathName}${paths.salesLeadReport}`;
  export const landownerreport = `${pathName}${paths.landownerreport}`;

// Sidebar Menu
export const menu = [
  { title: "Dashboard", to: landing },
  { title: "Sales", to: sales },
  { title: "CRM", to: crm },
  { title: "Digital Approval", to: digital_approval },
  { title: "Legal Module", to: legal_documents },
  { title: "Reports", to: reports },
  { title: "Customer Delight", to: delight },
  { title: "Apartment Handover", to: handover },
  { title: "Sales Accept Lead Report", to: salesLeadReport }, // ✅ Added here
  { title: "Landowner Report", to: landownerreport }, // ✅ Added here

];

const CRMHeadLayout = () => {
  const [showModal, setShowModal] = useState(false);
  const [unassignedLeads, setUnassignedLeads] = useState([]); // Store actual data

  useEffect(() => {
    const checkUnassignedLeads = async () => {
      try {
        const response = await axios.get(`${urls.baseURL}crms/unassigned_leads/`);

        if (response.data && response.data.length > 0) {
          setUnassignedLeads(response.data);
          setShowModal(true);
        }
      } catch (error) {
        console.error("Error fetching unassigned leads:", error);
      }
    };

    checkUnassignedLeads();
  }, []);

  return (
    <>
      {showModal && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
              <h3 style={{ margin: 0 }}>Unassigned Bookings</h3>
              <button onClick={() => setShowModal(false)} style={closeBtnStyle}>&times;</button>
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table style={tableStyle}>
                <thead>
                  <tr style={{ backgroundColor: '#f4f4f4' }}>
                    <th style={thStyle}>Project</th>
                    <th style={thStyle}>Customer</th>
                    <th style={thStyle}>Flat No</th>
                    <th style={thStyle}>Booking Date</th>
                    <th style={thStyle}>CRM Assignee</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedLeads.map((lead, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #eee' }}>

                      {/* Project */}
                      <td style={tdStyle}>
                        {lead?.lead?.project?.title || 'N/A'}
                      </td>

                      {/* Customer Name */}
                      <td style={tdStyle}>
                        {lead?.name || 'N/A'}
                      </td>

                      {/* Flat No */}
                      <td style={tdStyle}>
                        {lead?.apartment_details?.apartment_no || 'N/A'}
                      </td>

                      {/* Booking Date (not in API) */}
                      <td style={tdStyle}>
                        {lead?.updated_on
                          ? new Date(lead.updated_on).toLocaleDateString()
                          : 'N/A'}
                      </td>

                      <td><CrmChoice
                        customer_id={lead.id}
                        crm_assignee={lead.crm_assignee_id}
                      /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <RoleRoutes
        title="CRM Head"
        routes={routes}
        menu={menu}
        landing={landing}
        allowRoles={allowRoles}
        headerRight={<ProjectsDropDown />}
      />
    </>
  );
};

// --- Styles ---
const modalStyle = {
  position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
  backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex',
  justifyContent: 'center', alignItems: 'center'
};

const modalContentStyle = {
  background: 'white', padding: '25px', borderRadius: '12px',
  width: '80%', maxWidth: '700px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
};

const tableStyle = {
  width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px'
};

const thStyle = { padding: '12px', borderBottom: '2px solid #ddd' };
const tdStyle = { padding: '10px', borderBottom: '1px solid #eee' };

const closeBtnStyle = {
  border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer', color: '#888'
};

const actionBtnStyle = {
  backgroundColor: '#007bff', color: 'white', border: 'none',
  padding: '10px 20px', borderRadius: '5px', cursor: 'pointer'
};

// Routes
export const routes = [
  {
    path: paths.crm,
    exact: true,
    component: lazy(() => import("./crmhead")),
  },
  {
    path: paths.dashboard,
    exact: true,
    component: lazy(() => import("../../pages/crm-executives/dashboard")),
  },
  {
    path: `${paths.crm}/view/:customerId/request/add/:requestId/`,
    exact: true,
    component: lazy(() =>
      import(
        "../../pages/crm-executives/CRM/CustomerMaster/Request/RequestInformation"
      )
    ),
  },
  {
    path: paths.sales,
    exact: true,
    component: lazy(() => import("../../pages/crm-executives/sales_head")),
  },
  {
    path: paths.digital_approval,
    exact: true,
    component: lazy(() =>
      import("../../pages/crm-executives/CRM/digitalapprove")
    ),
  },
  {
    path: paths.legal_documents,
    exact: true,
    component: lazy(() =>
      import("../../pages/crm-executives/legal_documents")
    ),
  },
  {
    path: `${paths.legal_documents}/view/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../pages/crm-executives/LegalDocuments/Documents/LegalDetails")
    ),
  },
  {
    path: `${paths.reports}`,
    exact: true,
    component: lazy(() => import("../../pages/crm-head/ReportModule")),
  },

  // ✅ Added Sales Lead Report route
  {
    path: `${paths.salesLeadReport}`,
    exact: true,
    component: lazy(() => import("../../pages/crm-executives/SalesLeadReport")),
  },
  {
    path: `${paths.landownerreport}`,
    exact: true,
    component: lazy(() => import("../../pages/crm-executives/LandownerReport")),
  },
  {
    title: "Landowner Report",
    to: landownerreport,
  },

  {
    path: `${paths.handover}`,
    exact: true,
    component: lazy(() => import("./Handover/Apartmenthandover")),
  },
  {
    path: `${paths.handover}/view/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../pages/crm-head/Handover/HandoverDetails")
    ),
  },
  {
    path: `${paths.delight}`,
    exact: true,
    component: lazy(() => import("./CustomerDelight")),
  },
  {
    path: `${paths.delight}/view/:customerId`,
    exact: true,
    component: lazy(() => import("./Feedback/CustomerDetail")),
  },

  // CRM Executive-level Views (preserved)
  {
    path: `${paths.crm}/view/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../pages/crm-executives/CRM/CustomerMaster/CustomerDetail")
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/upr`,
    exact: true,
    component: lazy(() =>
      import(
        "../../pages/crm-executives/CRM/CustomerMaster/Upr/CustomerUpr"
      )
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/interest`,
    exact: true,
    component: lazy(() =>
      import(
        "../../pages/crm-executives/CRM/CustomerMaster/Interest/CustomerInterest"
      )
    ),
  },
  {
    path: `${paths.crm}/payment/view/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../crm-executives/CRM/CustomerPayments/PaymentDetailPage")
    ),
  },
  {
    path: `${paths.crm}/co-applicant/add/:customerId`,
    component: lazy(() =>
      import("../../components/crm-executive/crm/Add/AddCoApplicant")
    ),
  },
  {
    path: `${paths.crm}/bank-details/add/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../components/crm-executive/crm/Add/AddBankDetail")
    ),
  },
  {
    path: `${paths.crm}/bank-details/edit/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../components/crm-executive/crm/editDetails/EditBankDetails")
    ),
  },
  {
    path: `${paths.crm}/poa/add/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../components/crm-executive/crm/Add/PoaInfoAdd")
    ),
  },
  {
    path: `${paths.crm}/poa/:poaId/edit/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../components/crm-executive/crm/editDetails/PoaDetailsEdit")
    ),
  },
  {
    path: `${paths.crm}/contact-person/add/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../components/crm-executive/crm/Add/AddContactPerson")
    ),
  },
  {
    path: `${paths.crm}/contact-person/:conId/edit/:customerId`,
    exact: true,
    component: lazy(() =>
      import("../../components/crm-executive/crm/editDetails/ContactPersonEdit")
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/credit-notes/:noteId`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/PaymentDetailPage/TabSection/CreditNoteDetails"
      )
    ),
  },
  {
    path: `${paths.crm}/payment/view/:customerId/outstanding-payment`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/PaymentDetailPage/TabSection/CustomerOutstandingPayments"
      )
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/generate-customer-receipt/outstanding-payment`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/PaymentDetailPage/TabSection/CustomerOutstandingPayments"
      )
    ),
  },
  {
    path: `${paths.crm}/payment/view/:customerId/payment-statement`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/PaymentDetailPage/TabSection/CustomerPaymentStatement"
      )
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/generate-customer-receipt/payment-statement`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/PaymentDetailPage/TabSection/CustomerPaymentStatement"
      )
    ),
  },
  {
    path: `${paths.crm}/payment/view/:customerId/payment-received-from-customer`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/Receipts/PaymentReceivedReceipt"
      )
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/payment-received-receipt/:receiptId`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/Receipts/PaymentReceivedDetail"
      )
    ),
  },
  {
    path: `${paths.sales}/view/:customerId`,
    component: lazy(() =>
      import("./../crm-executives/Sales/Cancellation/CancellationAdd")
    ),
  },
  {
    path: `${paths.sales}/cancellationdisplay/view/:customerId`,
    component: lazy(() =>
      import("./../crm-executives/Sales/Cancellation/CancellationDisplayView")
    ),
  },
  {
    path: `${paths.sales}/booking_form/:bookingId`,
    component: lazy(() =>
      import("../../pages/crm-executives/Sales/BookingForm/BookingForm")
    ),
  },
  {
    path: `${paths.sales}/tower-wise-availability`,
    component: lazy(() => import("../sales-manager/TowerAvailability")),
  },
  {
    path: `${paths.sales}/tower-reports`,
    component: lazy(() => import("../sales-manager/TowerReport")),
  },
  {
    path: `${paths.sales}/project-cost-sheet`,
    component: lazy(() => import("../sales-manager/ProjectCostSheet")),
  },
  {
    path: `${paths.sales}/booking-details/:bookingId`,
    exact: true,
    component: lazy(() =>
      import("../../pages/crm-executives/Sales/BookingForm/BookingDetails")
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/generate-customer-receipt`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/Receipts/GenerateCustomerReceipt"
      )
    ),
  },
  {
    path: `${paths.digital_approval}/view_booking/:status/:customerId`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/DigitalApprove/DocumentList"
      )
    ),
  },
  {
    path: `${paths.legal_documents}/register/:customerId`,
    component: lazy(() =>
      import("../crm-executives/LegalDocuments/Registration/RegistrationDetails")
    ),
  },
  {
    path: `${paths.legal_documents}/aadhar-pan/:customerId`,
    component: lazy(() =>
      import(
        "../../pages/crm-executives/LegalDocuments/Registration/CustomerAadharTab"
      )
    ),
  },
  // "../../components/crm-executive/crm/Receipts/PaymentReceivedReceipt"

  {
    path: `${paths.crm}/view/:customerId/payment-received-from-customer`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/Receipts/PaymentReceivedReceipt"
      )
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/generate-customer-receipt/payment-received-receipt/:receiptId`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/Receipts/PaymentReceivedDetail"
      )
    ),
  },
  {
    path: `${paths.crm}/view/:customerId/final-notice`,
    exact: true,
    component: lazy(() =>
      import(
        "../../components/crm-executive/crm/PaymentDetailPage/TabSection/FinalRemainderLetter"
      )
    ),
  },

  {
    path: `${paths.sales}/apartment/:apartmentId`,
    component: lazy(() => import("../sales-manager/Apartment.js")),
  },
  {
    path: `${paths.legal_documents}/registration-remainder/:customerId`,
    component: lazy(() =>
      import(
        "../../pages/crm-executives/LegalDocuments/Registration/CustomerRegistrationRemainderTab"
      )
    ),
  },
  {
    path: `${paths.legal_documents}/apartment-plan/:customerId`,
    component: lazy(() =>
      import(
        "../../pages/crm-executives/LegalDocuments/Registration/InduvidualPlan"
      )
    ),
  },
];

// Allowed roles
export const allowRoles = [12];

// Default export
export default (
  <AuthRoute path={pathName}>
    <CRMHeadLayout />
  </AuthRoute>
);
